import React, { useState } from "react";
import { Card, Col, DropdownItem, Dropdown, DropdownToggle, DropdownMenu, Button, Row, ModalHeader, ModalBody, ModalFooter, Table, Modal, FormGroup } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import DatePicker from 'react-datepicker';
import Select from "react-select";
import { LoadingSpinner, formatDate } from "services/util";
import { EditDeleteButtons } from "components/common/Tables";
import { ApiClient } from "services";
import { Link } from "react-router-dom";

export const useSearchStates = () => {

  const [searchFront, setSearchFront] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [expiryStart, setExpiryStart] = useState(null);
  const [expiryEnd, setExpiryEnd] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);

  const handleSubscriptionStatus = (value) => {
    setSubscriptionStatus(value);
  }

  const hanStartDate = (date) => {
    setStartDate(date);
    setExpiryStart(null);
  };

  const hanEndDate = (date) => {
    setEndDate(date);
    setExpiryEnd(null);
  };

  const hanExpiryStart = (date) => {
    setExpiryStart(date);
    setStartDate(null);
  };

  const hanExpiryEnd = (date) => {
    setExpiryEnd(date);
    setEndDate(null);
  };

  const handInput = (event) => {
    setSearchFront(event.target.value);
  };

  const resetSearchStates = () => {
    setSearchFront(null);
    setStartDate(null);
    setEndDate(null);
    setExpiryStart(null);
    setExpiryEnd(null);
    setSelectedOption(null);
    setSubscriptionStatus(null);
  };

  return {
    searchFront,
    startDate,
    endDate,
    expiryStart,
    expiryEnd,
    selectedOption,
    subscriptionStatus,
    hanStartDate,
    hanEndDate,
    hanExpiryStart,
    hanExpiryEnd,
    handInput,
    setSelectedOption,
    handleSubscriptionStatus,
    resetSearchStates,
  };
};

export const ExportButton = ({ exportType, dropdownOpen, toggleDropdown, client, filters }) => {

  const {t} = useTranslation()

  const [isExporting, setExporting] = useState(false);

  const exportLink = async (format) => {
    try {
      setExporting(true)

      let config = {}

      if (format !== "pdf") {
        config["responseType"] = "blob"
      }

      let url = ""

      if (exportType === "organisation" || exportType === "company") {
        config["params"] = {
          "type": format,
          "limit": 10000,
          ...filters
        }
        url = `core/${exportType}`
      } else {
        url = `/core/export-${exportType}/get_file?type=${format}`
      }

      const response = await client.get(url, config);
      setExporting(false)
      
      const link = document.createElement('a');

      if (response.data?.encoding === "base64") {
        link.href = response.data.content;
      } else {
        const blob = new Blob([response.data], { type: format === "xlsx" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv" });
        link.href = window.URL.createObjectURL(blob);
      }

      link.download = `${exportType}-list.${format}`;
      link.click();

      window.URL.revokeObjectURL(link.href);
      NotificationManager.success(t("Export Generatated"))
    } catch (error) {
      NotificationManager.error(t("Unknown Error Occured While Generatating"))
      setExporting(false)
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      {isExporting ? (
        <Button disabled className="float-right">
          <span className="fa fa-spinner fa-spin" /> Exporting
        </Button>
      ) : (
        <Dropdown className="float-right mx-0" isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle caret>
            <i className="fas fa-file mr-2" /><Trans>Export</Trans>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => exportLink("csv")}>CSV</DropdownItem>
            <DropdownItem onClick={() => exportLink("xlsx")}>Excel</DropdownItem>
            <DropdownItem onClick={() => exportLink("pdf")}>PDF</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </>
  );
};

export const StatCard = ({ label, value, onClick, headers, header, description, t }) => {
  if(!headers)
    return null
  return (
    <Card body className="px-3 py-2 mb-2" title={description ? (t ? t(description) : description) : undefined}>
      <div className="d-flex flex-column align-items-center">
        <div
          style={{ lineHeight: "1.5rem", fontSize: ".875rem" }}
          className="font-weight-semibold text-nowrap"
        >
          <div><Trans>{label}</Trans></div>
          {onClick && headers[header] ? (
            <button
              type="button"
              className="btn btn-link p-0 d-block mx-auto text-center"
              style={{ lineHeight: "1.5rem", fontSize: ".875rem" }}
              onClick={(e) => { e.preventDefault(); onClick(); }}
            >
              {headers[header]}
            </button>
          ) : (
            <div className="text-center">{headers[header]}</div>
          )}
        </div>
      </div>
    </Card>
  );
};


export const RemoveAllButton = ({type, t, className}) => {

  const [disabled, setDisable] = useState()
  const [loading, setLoading] = useState()


  const handleNotif = async () => {
    setLoading(true)
    setTimeout(() => {
      NotificationManager.error(t(`The User Does Not Have Permission To Remove All ${type || ""}`));
      setLoading(false)
      setDisable(true)
    }, 5000);
  }
  
  return (
    <>
      {loading? 
        <Button className={className} disabled color="danger">{LoadingSpinner} <Trans>Removing</Trans></Button> 
        :
        <Button className={className} color="danger" onClick={() => handleNotif()} disabled={disabled}>
          <span className="fa fa-trash" /> <Trans>Remove All</Trans>
        </Button>
      }
    </>
    );
};

export const colStyle = {
  xs: false,
  md: 12,
  className: "pt-1 pb-1"
}


export const DynamicTable = ({ data, match, readOnly, url, type="", onDeleted, t }) => {

  const isModule = type === "Module"

  const [isOpen, setIsOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedName, setSelectedName] = useState(null);

  const toggle = () => setIsOpen(!isOpen);

  const onDelete = (i) => {
    setSelectedId(i.id);
    setSelectedName(i.name);
    toggle(); 
  };

  const client = ApiClient()

  const onConfirm = async () => {
    try {
      setDeleting(true);
      await client.delete(`/${url}/${selectedId}`);
      setTimeout(() => {
        NotificationManager.success(t(`${type} deleted successfully!`));
        setDeleting(false);
        onDeleted(); 
        setTimeout(() => {
          toggle();
        }, 200);
      }, 500);
    } catch (error) {
      console.error('Error deleting:', error);
      NotificationManager.error(t(`An error occurred while deleting ${selectedName || "this"} ${type.toLowerCase()}`));
      setDeleting(false);
      toggle();
    } 
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <Trans>
            Are you sure you want to delete {"the " + selectedName || "this"} {type.toLowerCase()}?
          </Trans>
        </ModalBody>
        <ModalFooter>
          {deleting ? 
            <Button disabled color="danger">{LoadingSpinner} <Trans>Deleting</Trans></Button>
            :
            <Button color="danger" onClick={onConfirm}><Trans>Delete</Trans></Button>
          }
          <Button color="secondary" onClick={toggle}><Trans>Cancel</Trans></Button>
        </ModalFooter>
      </Modal>
      <Table className="border">
        <thead>
          <tr>
            <th>
              <Trans>ID</Trans>
            </th>
            <th>
              <Trans>Name</Trans>
            </th>
            {isModule && 
              <th>
                <Trans>Category</Trans>
              </th>
            }
            <th>
              <Trans>Code</Trans>
            </th>
            <th>
              <Trans>Created at</Trans>
            </th>
            <th>
              <Trans>Updated at</Trans>
            </th>
            <th>
              <Trans>Status</Trans>
            </th>
            <th>
              <Trans>Monthly</Trans>
            </th>
            <th>
              <Trans>Yearly</Trans>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map((i) => {
            const monthly = i?.subscription_prices?.find(item => item.plan_type === 'Monthly')
            const yearly = i?.subscription_prices?.find(item => item.plan_type === 'Yearly')
            return (
            <tr key={i.id}>
              <td>{i.id}</td>
              <td><Trans><Link to={`${match.url}/${i.id}`}>{i.name}</Link></Trans></td>
              {isModule && <td><Trans>{i.category}</Trans></td>}
              <td>{i.code}</td>
              <td>{formatDate(i.created_at)}</td>
              <td>{formatDate(i.updated_at)}</td>
              <td>
              {i.active ? (
                    <span className="fa fa-check-circle text-success" />
                  ) : (
                    <span className="fa fa-times-circle text-danger" />
                  )}
              </td>
              <td>{monthly?.price || "-"} <span className="text-muted">{monthly?.currency}</span></td>
              <td>{yearly?.price || "-"} <span className="text-muted">{yearly?.currency}</span></td>
              <td className="text-right edit-btn">
                <EditDeleteButtons
                  url={match.url}
                  id={i.id}
                  onDelete={() => onDelete(i)}
                  readOnly={readOnly}
                />
              </td>
            </tr>
          )})}
        </tbody>
      </Table>
    </>
  );
};

export const SearchBarWithDate = ({ 
  placeholder,
  setSelectedOption,
  planOptions,
  i, 
  h,
  t, 
  hideStatus,
}) => {

  const options = [
    { value: 'expiry-date', label: t('Date by Expiry') },
    { value: 'date-joined', label: t('Date by Subscribed') }
  ];

  const statusOptions = [
    { value: 'Active', label: t('Active') },
    { value: 'Expired', label: t('Inactive') },
    { value: 'TrialActive', label: t('Trial Active') },
    { value: 'TrialExpired', label: t('Trial Inactive') },
    { value: 'Suspended', label: t('Suspended') },
    { value: 'Team', label: t('Team') },
    { value: 'XeroConnected', label: t('Connected to Xero') },
    { value: 'XeroNotConnected', label: t('Not Connected to Xero') },
  ]

  const [useSubscribed, setSubscribed] = useState(false);

  return (
      <>
        <FormGroup style={{ flex: 3 }}>
          <input
            className="form-control mb-2"
            placeholder={t(placeholder || "Search...")}
            type="text"
            id="searchInput"
            value={i.searchFront || ''}
            onChange={h.handInput}
          />
        </FormGroup>
        {planOptions && 
          <FormGroup style={{ flex: 1 }}>
            <Select
              options={planOptions}
              style={{backgroundColor:'#F4F7FE'}}
              onChange={setSelectedOption}
              value={i.selectedOption}
              isClearable
              placeholder={t("Filter by Subscription..")}
            />
          </FormGroup>
        }

      {!hideStatus && <FormGroup style={{ flex: 1 }}>
          <Select
            options={statusOptions}
            style={{ backgroundColor: '#F4F7FE' }}
            className="form-select-sm"
            clearable={true}
            searchable={false}
            multi={true}
            simpleValue={true}
            placeholder={t("Filter by Status..")}
            onChange={(sel) => h.handleSubscriptionStatus(sel)}
            value={i.subscriptionStatus}
          />
        </FormGroup>
      }

        {h.hanStartDate && h.hanExpiryStart && <>
          <FormGroup style={{ flex: 1 }}>
            <Select
              options={options}
              style={{backgroundColor:'#F4F7FE'}}
              className="form-select-sm"              
              clearable={false}
              searchable={false}
              onChange={(sel) => setSubscribed(sel.value === 'date-joined')}
              value={options.find(option => option.value === (useSubscribed ? 'date-joined' : 'expiry-date'))}
            />   
          </FormGroup>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', flex: 2 }}>
          {useSubscribed ? 
          <>
            <FormGroup style={{ flex: 1 }}>
              <DatePicker
                className="form-control"
                selected={i.startDate}
                placeholderText={t("From Subscribed Date")}
                onChange={h.hanStartDate}
                dateFormat="YYYY-MM-DD"
              />
            </FormGroup>

            <FormGroup style={{ flex: 1 }}>
              <DatePicker
                className="form-control"
                selected={i.endDate}
                placeholderText={t("To Subscribed Date")}
                onChange={h.hanEndDate}
                dateFormat="YYYY-MM-DD"
              />
            </FormGroup>
          </>
          :
          <>
          <FormGroup style={{ flex: 1 }}>
            <DatePicker
              className="form-control"
              selected={i.expiryStart}
              placeholderText={t("From Expiry Date")}
              onChange={h.hanExpiryStart}
              dateFormat="YYYY-MM-DD"
            />
          </FormGroup>

          <FormGroup style={{ flex: 1 }}>
            <DatePicker
              className="form-control"
              selected={i.expiryEnd}
              placeholderText={t("To Expiry Date")}
              onChange={h.hanExpiryEnd}
              dateFormat="YYYY-MM-DD"
            />
          </FormGroup>
          </>
          }
          
        </div>
        </>}     
        </>
          );
        };

export const TableValues = ({label, value}) => (
  <tr>
    <th><Trans>{label}</Trans></th><td>{value}</td>
  </tr>
)

export const ModalTable = ({headers, handleModalClose, showModal}) => {

    if(!headers)
    return null
  return (

      <Modal isOpen={showModal} toggle={handleModalClose} contentLabel="Cancelling the Subscription">
        <ModalHeader closeButton>Invoice Statistics</ModalHeader>
        <ModalBody>
          <Table className="border">
            <tbody>
              <TableValues label="Total Invoices" value={headers.total_invoices}/>
              <TableValues label="Total Amount" value={headers.total_amount_sum}/>
              <TableValues label="Unpaid Invoices" value={headers.total_invoices_unpaid}/>
              <TableValues label="Unpaid Invoice Amount" value={headers.total_unpaid_amount}/>
              <TableValues label="Paid Invoice Amount" value={headers.total_paid_amount}/>
              <TableValues label="Paid Invoices" value={headers.total_invoices_paid}/>
              <TableValues label="Cancelled Invoices" value={headers.total_invoices_cancelled}/>
              <TableValues label="Cancelled Invoice Amount" value={headers.total_cancelled_amount}/>
            </tbody>
          </Table>
          <p><Trans>These invoices are generated for all the users for subscriptions through online <a href="/aaa">payment.</a></Trans></p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleModalClose}>
            <Trans>Close</Trans>
          </Button>
        </ModalFooter>
      </Modal>
        );
      };
      

export const SuperUserStatsCard = ({headers, onFilterClick, t}) => {

  const onClick = (params) => onFilterClick && onFilterClick(params);

  return (
    <Row className="mb-2">
      <Col lg>
        <StatCard
          label="Organisations"
          headers={headers}
          header='total_organisations'
          onClick={() => onClick({})}
          t={t}
        />
      </Col>
      <Col lg>
        <StatCard
          label="Active Subscriptions"
          headers={headers}
          header='total_active_organisations'
          onClick={() => onClick({ subscription_status: 'Active' })}
          t={t}
        />
      </Col>
      <Col lg>
        <StatCard
          label="Will expire in 1 month"
          description="Active subscriptions ending within the next 30 days"
          headers={headers}
          header='total_about_to_expire_organisations'
          onClick={() => onClick({ card_filter: 'expiring_soon' })}
          t={t}
        />
      </Col>
      <Col lg>
        <StatCard
          label="Expired Subscriptions"
          headers={headers}
          header='total_expired_organisations'
          onClick={() => onClick({ subscription_status: 'Expired' })}
          t={t}
        />
      </Col>
      <Col lg>
        <StatCard
          label="Cancelled Subscriptions"
          headers={headers}
          header='total_cancelled_organisations'
          onClick={() => onClick({ subscription_status: 'Cancelled' })}
          t={t}
        />
      </Col>
      <Col lg>
        <StatCard
          label="Non Subscribed Organisations"
          headers={headers}
          header='total_non_subscribed_organisations'
          onClick={() => onClick({ card_filter: 'non_subscribed' })}
          t={t}
        />
      </Col>
      <Col lg>
        <StatCard
          label="Not accessed in last 3 days"
          description="Organisations not accessed in the last 3 days"
          headers={headers}
          header='total_not_in_use_organisations'
          onClick={() => onClick({ card_filter: 'not_in_use' })}
          t={t}
        />
      </Col>
      <Col lg>
        <StatCard
          label="Not connected to Xero in last 3 days"
          description="Organisations not connected to Xero in the last 3 days"
          headers={headers}
          header='total_not_connected_organisations'
          onClick={() => onClick({ card_filter: 'not_connected' })}
          t={t}
        />
      </Col>
    </Row>

  )
}


export default SuperUserStatsCard;
